import { Navigate } from 'react-router-dom';
import { useAuth } from '@/stores/use-auth';

/** Settings child routes available only when the session is Next-shell eligible (DC-324). */
export const NEXT_SHELL_ONLY_SETTINGS_ROUTES = [
  '/settings/provider-connections',
  '/settings/trigger-policy',
  '/settings/context-freshness-policy',
  '/settings/sdd-generation-gate-policy',
  '/settings/citation-quality',
  '/settings/mcp',
] as const;

export const NEXT_SHELL_SETTINGS_FALLBACK = '/settings/profile';

export function useEligibleForNextShell(): boolean {
  return useAuth((s) => s.user?.nextNavigation?.eligibleForNextShell ?? false);
}

/**
 * Renders SDD governance settings only for Next-shell-eligible sessions; Classic redirects to profile.
 */
export function NextShellSettingsGate({ children }: { children: React.ReactNode }) {
  const eligible = useEligibleForNextShell();
  if (!eligible) {
    return <Navigate to={NEXT_SHELL_SETTINGS_FALLBACK} replace />;
  }
  return <>{children}</>;
}
